import React from "react";
import { makeStyles } from "@mui/styles";
import {
  Backdrop,
  Badge,
  Button,
  Divider,
  Fade,
  FormControl,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReactComponent as PhoneIcon } from "../images/phoneicon.svg";
import { TfiEmail } from "react-icons/tfi";
import { RiUser3Line } from "react-icons/ri";
import { FaCloudUploadAlt } from "react-icons/fa";


const useStyles = makeStyles((theme) => ({
  badge: {
    "& .MuiBadge-badge": {
      backgroundColor: "#e1a405",
      transform: " scale(0.7) translate(-50%, -50%)",
      transformOrigin: "300% 50%",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    zIndex: "1",
    width: "40%",
    border: "2px solid #000",
    position: "relative",
    boxShadow:
      "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);",
    padding: "16px 10px 24px",
  },
  buttoncont: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
    "& h5": {
      margin: "0",
    },
  },
  button: {
    background: "transparent",
    border: "none",
    color: "blue",
    cursor: "pointer",
  },
  crossbtn: {
    color: "black",
    cursor: "pointer",
  },
  notificationlistpara: {
    margin: "0",
  },
  messageform: {
    width: "80%",
    margin: "0 auto",
    "@media (max-width: 600px)": {
      width: "100%",
    },
    "& .MuiInputBase-root": {
      padding: "1rem 1rem",
    },
    "& .MuiInputBase-input": {
      padding: "0",
      fontFamily: "Jost",
      fontWeight: "500",
    },
    "& input:-internal-autofill-selected": {
      backgroundColor: "#fff",
    },
    "& .MuiTextField-root": {
      background: "white",
      borderRadius: "6px",
      boxShadow: "inset 0px 3px 11px 0px rgba(0, 0, 0, 0.17) ",
      marginBottom: "1rem",
    },
    "& .MuiFormControl-root": {
      width: "100%",
      "@media screen and (min-width: 320px) and (max-width: 767px)": {
        margin: "8px 0",
      },
      "& .MuiTypography-h6": {
        color: "#252525",
        fontSize: "1rem",
        fontWeight: "500",
        textTransform: "capitalize",
        fontFamily: "Jost",
      },
      "& .MuiFormControlLabel-label": {
        fontFamily: "Jost",
        fontSize: "0.9rem",
        textTransform: "capitalize",
      },
      "& .MuiInput-underline:after": {
        borderBottom: "none",
      },
      "& .MuiInput-underline:before": {
        borderBottom: "none",
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottom: "none",
      },
      "& input:-internal-autofill-selected": {
        backgroundColor: "#fff",
      },
      "& .MuiButton-fullWidth": {
        width: "100%",
        color: "white",
        "@media screen and (min-width: 320px) and (max-width: 767px)": {
          alignSelf: "center",
        },
      },
    },
  },
  bluecustombtn: {
    background: "linear-gradient(90deg, #141E30 0%, #243B55 100%)",
    color: "white",
    marginTop: "2.5rem",
    padding: "0.5rem 1rem",
    borderRadius: "0.4rem",

    "& .MuiButton-label": {
      fontSize: "1rem",
      fontFamily: "Jost",
      fontWeight: "400",
    },
  },
  input: {
    display: "none",
  },
  uploadcont: {
    marginBottom: "1rem",
    "& .MuiButton-root": {
      backgroundColor: "#ed8c17",
      "&:hover": {
        backgroundColor: "#ed8c17",
      },
    },
  },
}));

export default function TransitionsModal({
  open,
  handleOpen,
  handleClose,
  setOpen,
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  const handleKnowMoreClick = () => {
    window.open("https://forms.gle/ENAgEcmMuu9pDADc9", "_blank");
    setOpen(false);
  };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            {/* <h2 id="transition-modal-title">Transition modal</h2> */}
            <div className={classes.buttoncont}>
              <h5>Application Forms</h5>
              <button className={classes.crossbtn} onClick={handleClose}>
                X
              </button>
            </div>
            <Divider />
            <div className={classes.messageform}>
              <FormControl sx={{ m: 1, width: "25ch" }}>
                <Typography
                  className={classes.inputhead}
                  variant="h6"
                  gutterBottom
                >
                  Your Name <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  id="name"
                  type="text"
                  placeholder="Enter your Name"
                  // onChange={handleChange}
                  name="full_name"
                  // value={formData.full_name}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <RiUser3Line />
                      </InputAdornment>
                    ),
                  }}
                />

                <Typography
                  className={classes.inputhead}
                  variant="h6"
                  gutterBottom
                >
                  Mobile No. <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  id="mobilenumber"
                  type="mobilenumber"
                  placeholder="+91 8965 458 888"
                  // onChange={handleChange}
                  name="phone"
                  // value={formData.phone}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography
                  className={classes.inputhead}
                  variant="h6"
                  gutterBottom
                >
                  Email Address <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  id="email"
                  type="email"
                  placeholder="Johndeere43545@gmail.com"
                  // onChange={handleChange}
                  name="email"
                  // value={formData.email}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <TfiEmail />
                      </InputAdornment>
                    ),
                  }}
                />
                <div className={classes.uploadcont}>
                  <input
                    accept="image/*"
                    className={classes.input}
                    id="contained-button-file"
                    multiple
                    type="file"
                  />
                  <label htmlFor="contained-button-file">
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      startIcon={<FaCloudUploadAlt />}
                    >
                      UPLOAD CV
                    </Button>
                  </label>
                </div>
                <Button
                  className={classes.bluecustombtn}
                  fullWidth
                  // onClick={handleSubmit}
                >
                  Send Message
                </Button>
              </FormControl>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
